function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import { stringifyHelper } from './sinks/utils/stringifyHelper'; // tslint:disable-next-line:no-any

/**
 * Calls a telemetry sink function (e.g. 'log') on the supplied array of sinks, with
 * error handling logic if one of the telemetry sinks errors.
 *
 * @param functionName The name of the ITelemetrySink function to call on each sink.
 * @param functionParams The params to pass to the ITelemetrySink function for each sink.
 * @param telemetrySinksToCall The telemetry sinks.
 */
export function callFunctionOnTelemetrySinks(functionName, functionParams, telemetrySinksToCall, context) {
  var depth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  var logErrorWithRemainingTelemetrySinks = function logErrorWithRemainingTelemetrySinks(error, erroredSinkIndex) {
    var erroredSink = telemetrySinksToCall[erroredSinkIndex];
    var errorName = 'TelemetrySinkFailure';
    var errorMessage = "Failed to execute function '".concat(functionName, "' on TelemetrySink '").concat(erroredSink && erroredSink.id, "'"); // Limit the recursion depth to 1
    // If it exceeds, directly log to the console

    if (depth > 1) {
      console.log(errorName, errorMessage);
      return;
    } // Failure while trying to log an event with a telemetry sink - try to log the failure with other telemetry Sinks


    var remainingTelemetrySinks = [].concat(_toConsumableArray(telemetrySinksToCall.slice(0, erroredSinkIndex)), _toConsumableArray(telemetrySinksToCall.slice(erroredSinkIndex + 1, telemetrySinksToCall.length)));

    if (remainingTelemetrySinks.length) {
      callFunctionOnTelemetrySinks('error', [{
        name: errorName,
        data: {
          name: errorName,
          message: errorMessage
        },
        context: context
      }], remainingTelemetrySinks, context, depth + 1);
    } else {
      throw new Error("[".concat(errorName, "] ").concat(errorMessage, " \n").concat(stringifyHelper(error)));
    }
  };

  telemetrySinksToCall.map(function (sink, index) {
    try {
      var fn = sink[functionName];

      if (fn) {
        fn.apply(void 0, _toConsumableArray(functionParams));
      }
    } catch (e) {
      return logErrorWithRemainingTelemetrySinks(e, index);
    }
  });
}
//# sourceMappingURL=callFunctionOnTelemetrySinks.js.map